module.exports = __webpack_public_path__ + "img/img-chart-04.df58769c.png";